module.exports = __webpack_public_path__ + "img/logo.a69f67e1.webp";